import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { API_URL } from './lmShared';

export const LmAssignDialog = ({ mode, leadIds, users, onClose, onDone }) => {
  const [target, setTarget] = useState('');
  const [pool, setPool] = useState([]);
  const [share, setShare] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (mode) { setTarget(''); setPool([]); setShare(true); } }, [mode]);

  const save = async () => {
    if (mode === 'single' && !target) { toast.error('Escolha o comercial'); return; }
    if (mode === 'round_robin' && pool.length < 1) { toast.error('Escolha pelo menos um comercial'); return; }
    setSaving(true);
    try {
      const r = await axios.post(`${API_URL}/leads/bulk-assign`, {
        lead_ids: leadIds, mode, assigned_to: target, comercial_ids: pool, share_history: share,
      });
      toast.success(r.data.message);
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Erro ao atribuir');
    } finally {
      setSaving(false);
    }
  };

  const togglePool = (id) => setPool((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));

  return (
    <Dialog open={!!mode} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" aria-describedby={undefined} data-testid="lm-assign-dialog">
        <DialogHeader>
          <DialogTitle>{mode === 'round_robin' ? 'Distribuir por vários' : 'Atribuir a…'} ({leadIds.length} lead{leadIds.length > 1 ? 's' : ''})</DialogTitle>
        </DialogHeader>
        {mode === 'single' ? (
          <Select value={target} onValueChange={setTarget}>
            <SelectTrigger data-testid="lm-assign-target"><SelectValue placeholder="Escolha o comercial" /></SelectTrigger>
            <SelectContent>
              {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}
            </SelectContent>
          </Select>
        ) : (
          <div className="max-h-60 overflow-y-auto border rounded-md p-2 space-y-1" data-testid="lm-assign-pool">
            {users.map((u) => (
              <label key={u.id} className="flex items-center gap-2 text-sm cursor-pointer">
                <input type="checkbox" checked={pool.includes(u.id)} onChange={() => togglePool(u.id)} className="accent-[#2D3E6F]" data-testid={`lm-pool-${u.id}`} />
                {u.name}
              </label>
            ))}
          </div>
        )}
        <label className="flex items-start gap-2 text-sm cursor-pointer bg-slate-50 rounded-md p-2" data-testid="lm-share-history">
          <input type="checkbox" checked={share} onChange={(e) => setShare(e.target.checked)} className="mt-0.5 accent-[#2D3E6F]" />
          <span>O novo comercial pode ver o histórico anterior<br /><span className="text-[11px] text-slate-500">Se desmarcar, só vê a lead a partir de agora. Super Admin e Gestor veem sempre tudo.</span></span>
        </label>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={save} disabled={saving} className="bg-[#2D3E6F] hover:bg-[#1a2a4a]" data-testid="lm-assign-save">Confirmar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
